import React from "react";
import { StyledLink } from "./style";

export const LoginLink = ({ children, onClick }) => {
  return <StyledLink onClick={onClick}>{children}</StyledLink>;
};
